import scraperApi from "api";

import AuthForm from "components/AuthForm";
import AuthPage, { AuthPageLink, AuthPageLinks } from "components/AuthPage";
import ExtLink from "components/ExtLink";
import { LinkText } from "components/LinkText";

import { path as HomePath } from "v2/pages/home/HomeRoute";


export default function Signup() {
  return (
    <AuthPage
      title="Sign up"
      heading={[
        "Create an account",
        <>
          Get started with 5000 free API credits. No credit card required.
          <br/>
          <ExtLink to="https://hubs.ly/Q03l-kpr0">
            <LinkText>
              Contact us
            </LinkText>
          </ExtLink> {" "}
          to claim up to 50 million scraping credits and properly test our speed and success rate on your domains.
        </>
      ]}
    >
      <AuthForm
        googleButtonMode="signup"
        googleButtonText="Sign up with Google"
        googleCallback={scraperApi.auth.google.signup}
        googleRedirect={ HomePath }
        gitHubButtonText="Sign up with GitHub"
        gitHubRedirectUri={process.env.REACT_APP_API_URL + '/oauth/github/sign-up'}
        emailButtonText="Sign up with email"
        showCaptcha
        showTerms
        defaultErrorMessage="There was an error signing up. Please try again later."
      />

      <AuthPageLinks>
        <AuthPageLink text="Already have an account?" link={{ to: "/login", text: "Login here" }} />
        <AuthPageLink text="Having trouble signing up? Contact" link={{ to: "mailto:support@scraperapi.com", text: "support@scraperapi.com" }} />
      </AuthPageLinks>
    </AuthPage>
  );
}
